var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["className", "label", "type"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import classNames from "classnames";
import React from "react";
import { MenuItem, TYPE as MENU_ITEM_TYPE, TYPE_TO_CLASSNAME } from "../item/Item";
import { menuVerticalSubmenuCls, menuVerticalSubmenuItemCls } from "./Menu.less";
import { menuListItemWithImgCls } from "../list/List.less";
function VerticalMenuSubmenu(_ref) {
  var items = _ref.items, opened = _ref.opened, _ref$onClick = _ref.onClick, _onClick = _ref$onClick === void 0 ? null : _ref$onClick;
  return items && items.length ? /* @__PURE__ */ React.createElement("ul", {
    className: menuVerticalSubmenuCls
  }, items.map(function(_ref2) {
    var columnItems = _ref2.items;
    return columnItems.map(function(_ref3, index) {
      var className = _ref3.className, label = _ref3.label, type = _ref3.type, itemProps = _objectWithoutProperties(_ref3, _excluded);
      return /* @__PURE__ */ React.createElement("li", {
        className: classNames(menuVerticalSubmenuItemCls, TYPE_TO_CLASSNAME[type || MENU_ITEM_TYPE.LINK], itemProps.image && menuListItemWithImgCls, className),
        key: index
      }, /* @__PURE__ */ React.createElement(MenuItem, _extends({
        type,
        label: Array.isArray(label) ? label.join(" ") : label,
        opened
      }, itemProps, typeof _onClick === "function" ? {
        onClick: /* @__PURE__ */ __name(function onClick(e) {
          if (typeof itemProps.onClick === "function") {
            itemProps.onClick(e);
          }
          _onClick(e);
        }, "onClick")
      } : null)));
    });
  })) : null;
}
__name(VerticalMenuSubmenu, "VerticalMenuSubmenu");
export {
  VerticalMenuSubmenu
};
